import Product from '../../../../model/product/product';
import ProductPlacement from '../../../../model/product/product-placement';
import { ProductTypes } from '../../../../model/product/product-type';
import Windowsticker from '../../../../model/product/windowsticker/windowsticker';
import CustomWindowsticker from '../../../../model/product/windowsticker/custom-windowsticker';
import {
  CLIENT_WINDOW_STICKER_TYPE,
  ClientWindowSticker,
} from '../../../../model/product/windowsticker/client-windowsticker';
import WindowStickerPlacement from '../../../../model/product/windowsticker/windowsticker-placement';
import ProductFactory from '../../product-factory';
import WindowstickerCreationParameters from './windowsticker-creation-parameters';
import { EMPTY_OBJECT } from '../../../../../globals/globals';
import { ClientStickerPart } from 'src/app/model/product/windowsticker/client-sticker-part';

export default class WindowStickerFactory extends ProductFactory<WindowstickerCreationParameters> {
  protected createProductTemplate(
    parameters: WindowstickerCreationParameters
  ): Product {
    switch (parameters.type) {
      case ProductTypes.WINDOWSTICKER.value:
        return new Windowsticker();
      case ProductTypes.CUSTOMWINDOWSTICKER.value:
        return new CustomWindowsticker();
      case CLIENT_WINDOW_STICKER_TYPE:
        const clientWindowSticker = new ClientWindowSticker();
        clientWindowSticker.temporaryMaterial = null;
        clientWindowSticker.calculatedTypeLabel = 'Raamsticker';
        const clientStickerPart = new ClientStickerPart();
        clientStickerPart.instance = EMPTY_OBJECT;
        clientWindowSticker.clientStickerParts = [clientStickerPart];
        return clientWindowSticker;
      default:
        throw new Error(`type not recognized: ${parameters.type}`);
    }
  }

  protected createProductPlacement(): ProductPlacement {
    const toReturn = new WindowStickerPlacement();
    toReturn.productPlacementType = 'WindowStickerPlacement';
    return toReturn;
  }

  getProductCreationParameters(
    parameters: any
  ): WindowstickerCreationParameters {
    if (parameters.type == null) {
      throw new Error('Missing required parameter: type');
    }
    if (typeof parameters.type !== 'string') {
      throw new Error('type must be string');
    }
    if (!WindowStickerFactory.VALID_TYPES.includes(parameters.type)) {
      throw new Error(`type not recognized: ${parameters.type}`);
    }
    return new WindowstickerCreationParameters(parameters.type);
  }

  private static readonly VALID_TYPES = [
    ProductTypes.WINDOWSTICKER.value,
    ProductTypes.CUSTOMWINDOWSTICKER.value,
    CLIENT_WINDOW_STICKER_TYPE,
  ];
}
